// Rol izin matrisinin istemci tarafı — ekran 14'teki tablo.
//
// ÖNEMLİ: burası bir GÜVENLİK SINIRI DEĞİL. Asıl kapı sunucudaki uç filtresi
// (Btys.Api/Ortak/YetkiFiltresi.cs). Buradaki gizleme yalnız kullanıcıya
// erişemeyeceği şeyi göstermemek için; butonu saklamak ucu korumaz.

import { useOturum } from './oturum'

export type Modul =
  | 'MalKabul'
  | 'Laboratuvar'
  | 'Besleme'
  | 'Beyan'
  | 'Hareketler'
  | 'FiloCariler'
  | 'Ayarlar'
  | 'StokKartlari'
  | 'Uniteler'
  // Yazım sunucudaki Modul enum üyesiyle BİREBİR aynı olmalı: izin sözlüğünün
  // anahtarı `Modul.ToString()` (Auth/Uclar.cs:119), yani PascalCase.
  | 'Entegrasyon'

export type Erisim = 'yok' | 'oku' | 'yaz'

const SIRA: Record<Erisim, number> = { yok: 0, oku: 1, yaz: 2 }

export function useYetki() {
  const { durum } = useOturum()

  const izinler = durum?.izinler ?? {}
  const erisim = (m: Modul): Erisim => (izinler[m] as Erisim) ?? 'yok'

  return {
    /** Modülde en az istenen düzeyde hak var mı? */
    izinVar: (m: Modul, gereken: Erisim = 'oku') => SIRA[erisim(m)] >= SIRA[gereken],
    erisim,
    /** K16: rol beyan yazabilmeli VE yetki_onay bayrağı açık olmalı. */
    onaylayabilir: Boolean(durum?.yetkiOnay) && SIRA[erisim('Beyan')] >= SIRA.yaz,
    /** K15/K39: rol hareket yazabilmeli VE yetki_storno açık olmalı. */
    stornolayabilir: Boolean(durum?.yetkiStorno) && SIRA[erisim('Hareketler')] >= SIRA.yaz,
    rol: durum?.kullanici.rol ?? null,
  }
}

/**
 * Erişimi olmayan kullanıcıya sayfayı hiç açmaz. Sunucu zaten 403 döner ama
 * kullanıcıyı boş bir ekranla baş başa bırakmak yerine nedenini söylüyoruz.
 */
export function YetkiKapisi({
  modul,
  gereken = 'oku',
  children,
}: {
  modul: Modul
  gereken?: Erisim
  children: React.ReactNode
}) {
  const { izinVar, rol } = useYetki()

  if (izinVar(modul, gereken)) return <>{children}</>

  return (
    <>
      <div className="crumb">
        <b>Erişim yok</b>
      </div>
      <div className="card" style={{ padding: 18 }}>
        <div className="sect-t">Bu sayfaya erişim yetkiniz yok</div>
        <div className="cell-sub" style={{ padding: '10px 2px', lineHeight: 1.7 }}>
          Rolünüz <b>{rol ?? '—'}</b> bu modülde{' '}
          <b>{gereken === 'yaz' ? 'yazma' : 'okuma'}</b> hakkı taşımıyor.
          <br />
          Yetki değişikliği için tesis sorumlusuna başvurun (Ayarlar → Kullanıcılar).
        </div>
      </div>
    </>
  )
}
